import React, { useEffect, useState } from 'react';

import './style/site.css';

import Top from './components/Top';
import Status from './components/Status';
import AboutContent from './components/about';
import WritingsContent from './components/writings';
import Photos from './components/Photos';
import Reading from './components/Reading';

// The home page scrolls through who Nico is and his writing.
// Photos and Reading are their own pages, opened from the nav, never reached by scrolling.
const PAGES = ['photos', 'reading'];
const pageOf = () => (PAGES.includes(window.location.hash.slice(1)) ? window.location.hash.slice(1) : 'home');

function App() {
  const [page, setPage] = useState(pageOf);

  useEffect(() => {
    const onHash = () => {
      const next = pageOf();
      setPage(next);
      // Switching pages starts at the top; a section link on the home page scrolls to it.
      const id = window.location.hash.slice(1);
      requestAnimationFrame(() => {
        const el = next === 'home' && id && document.getElementById(id);
        if (el) el.scrollIntoView();
        else window.scrollTo(0, 0);
      });
    };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  return (
    <div className="page">
      <Top page={page} />
      <main>
        {page === 'photos' && <Photos />}
        {page === 'reading' && <Reading />}
        {page === 'home' && (
          <>
            <AboutContent />
            <WritingsContent />
          </>
        )}
      </main>
      <footer className="foot">
        <p>Say hi on <a href="https://x.com/nicoypei" target="_blank" rel="noopener noreferrer">X</a> or at <a href="mailto:nicopei321@gmail.com">nicopei321@gmail.com</a>.</p>
      </footer>
      <Status />
    </div>
  );
}

export default App;
